import { RootState } from "@redux/app/store"
import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit"

export type OfflineVesselsList = {
	name: string
	id: number
	lastUpdateTimestamp: number | null
}[]

const initialState: OfflineVesselsList | null = null

const offlineVesselsSlice = createSlice<
	OfflineVesselsList | null,
	{
		setOfflineVessels: CaseReducer<OfflineVesselsList | null, PayloadAction<OfflineVesselsList>>
	}
>({
	name: "offlineVessels",
	initialState,
	reducers: {
		setOfflineVessels(state, action: PayloadAction<OfflineVesselsList>) {
			return action.payload
		},
	},
})

export const getOfflineVessels = (state: RootState) => state.offlineVessels

export const { setOfflineVessels } = offlineVesselsSlice.actions

export default offlineVesselsSlice.reducer
